/** Hashtag / mention parsing shared by client (live highlighting) and server (indexing). */
const HASHTAG_RE = /(^|[^\p{L}\p{N}_])#([\p{L}\p{N}_]{1,50})/gu;
const MENTION_RE = /(^|[^\p{L}\p{N}_.])@([a-z0-9_.]{2,24})/giu;

export function extractHashtags(text: string): string[] {
  const out = new Set<string>();
  for (const m of text.matchAll(HASHTAG_RE)) out.add(m[2]!.toLowerCase());
  return [...out].slice(0, 30);
}

export function extractMentions(text: string): string[] {
  const out = new Set<string>();
  for (const m of text.matchAll(MENTION_RE)) out.add(m[2]!.toLowerCase());
  return [...out].slice(0, 20);
}

export const USERNAME_RE = /^[a-z0-9_.]{2,24}$/;

export function formatCount(n: number): string {
  if (n < 1000) return String(n);
  if (n < 1_000_000) return `${trim(n / 1000)}K`;
  if (n < 1_000_000_000) return `${trim(n / 1_000_000)}M`;
  return `${trim(n / 1_000_000_000)}B`;
}

function trim(v: number): string {
  return (v >= 100 ? Math.round(v) : Math.round(v * 10) / 10).toString().replace('.', ',');
}

export function formatDuration(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  const m = Math.floor(s / 60);
  return `${m}:${String(s % 60).padStart(2, '0')}`;
}
